<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.27" height="13.618" viewBox="0 0 13.27 13.618">
    <g id="refresh" transform="translate(0.954 0.808)">
      <path
        id="Path_124"
        data-name="Path 124"
        d="M3.71,6.653a6,6,0,1,1,0,4.613"
        transform="translate(-3.683 -2.959)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        fill-rule="evenodd" />
      <path
        id="Path_125"
        data-name="Path 125"
        d="M3.67,4.58V7.113a.133.133,0,0,0,.133.133H6.337"
        transform="translate(-3.67 -3.499)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        fill-rule="evenodd" />
    </g>
  </svg>
</template>
